import { AnalyticsEvent } from "./analyticsEvent";

class EnquiryFormFailureEvent extends AnalyticsEvent {
    public readonly errorCondition: string;
    constructor(errorCondition: string) {
        super();
        this.errorCondition = errorCondition.replace(/(\:\s+)/gi,":").replace(/(\s+)/gi, "_").toLowerCase();
    }
}
export { EnquiryFormFailureEvent }